import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/common/models/user';
import { CommonService } from 'src/app/common/services/common.service';
import { ClearAdvanceSearch } from 'src/app/state/advance-search/advance-search.actions';
import { ClearAuthState } from 'src/app/state/auth/auth.actions';
import { AuthState } from 'src/app/state/auth/auth.state';
import { ClearRecordsOf, SetRecordsOfData } from 'src/app/state/records-of/records-of.actions';
import { ClearUpdateData } from 'src/app/state/update-settings/update-settings.actions';
import { AuthService } from '../../areas/user/auth/providers/auth.service';
import { UserService } from '../../areas/user/auth/providers/user.service';
import { ComponentMessagingService } from '../../common/services/component-messaging.service';
import { ClearLegacyRecords, SetLegacyRecordsData } from 'src/app/state/legacy-records/legacy-records.actions';
import { ClearFilterRecords } from 'src/app/state/filter-records/filter-records.actions';
import { ClearRecordAsSeenBy } from 'src/app/state/record-as-seen-by/record-as-seen-by.actions';
import { ClearFamilyTrailData } from 'src/app/state/family-tree/family-tree.actions';
import { FamilyTreeState, FamilyTreeStateModel } from 'src/app/state/family-tree/family-tree.state';
import { IFamilyTreeTrail } from 'src/app/common/models/IFamilyTreeTrail';
import { take } from 'rxjs/operators';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { FamilyTreeService } from 'src/app/areas/user/profile/pages/family-tree/services/family-tree.service';
import { HttpService } from 'src/app/common/services/http.service';
import { environment } from 'src/environments/environment';
import { ApiMethod, GetURL } from 'src/app/common/const/requests-methods';
import { RecordsOfState } from 'src/app/state/records-of/records-of.state';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/common/services/toast.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Select(AuthState.user) user$: Observable<User>;
    @Select(FamilyTreeState.getFamilyVisitedProfileState) familyVisitedProfile$: Observable<boolean>;
    @Select(FamilyTreeState.getFamilyTrail) familyTrail$: Observable<IFamilyTreeTrail[]>;
    @SelectSnapshot(FamilyTreeState.getFamilyDataState) familyTreeSnapshot: FamilyTreeStateModel | null;
    @SelectSnapshot(RecordsOfState.getRecordsOfStateData) recordsOfStateData: any;

    public userName: string;
    public userEmail: string;
    public userInitials: string;
    public menuVisibility: any;
    public profilePictureUrl: string;
    public defaultImageUrl: string;
    public adminPageTitle: string;
    public adminUserName: string;
    public currentActiveUrl: string;
    public fullName: string;
    public cycanRecordClicked = false;
    public cycanFamliyTreeClicked = false;
    private outerMenuRouter: string[];
    private innerMenuRoutes: string[];
    private adminMenuRoutes: string[];
    private grayLeafMenu: string[];
    private routerEventsSubscription: Subscription;
    private userId: number;
    private visitedProfileUserId: number;


    constructor(
        private authService: AuthService,
        private userService: UserService,
        private router: Router,
        private componentMessagingService: ComponentMessagingService,
        private commonService: CommonService,
        private store: Store,
        private cdr: ChangeDetectorRef,
        private familyTreeService: FamilyTreeService,
        private httpService: HttpService,
        private translateService: TranslateService,
        private toastService: ToastService) {
        this.menuVisibility = {
            header: false,
            inner: false,
            admin: false,
            colorLeaf: true,
            familyTree: true
        };

        this.outerMenuRouter = [
            'sign-up',
            'password',
            'admin'
        ];

        this.innerMenuRoutes = [
            'profile/records',
            'profile/tags',
            'profile/advance-records-search',
            'profile/contacts',
            'profile/search',
            '/profile/past-search',
            'profile/create-update-tag',
            'profile/create-update-record',
            'profile/create-contact',
            'profile/past-search',
            'profile/legacy-vaults',
            'profile/legacy-records',
            'profile/legacy-public-records',
            'profile/my-will-records',
            'profile/other-users-profiles',
            'profile/user-sharing-with-me',
            'profile/record-as-seen-by',
            'home',
            'profile/family-tree',
            'profile/create-update-family-members',
            'profile/family-members'
        ];

        this.adminMenuRoutes = [
            'admin/global-stats',
            'admin/global-system-settings',
            '/admin/global-users-list',
            '/admin/create-edit-global-user'
        ];

        this.grayLeafMenu = [
            '/profile/advance-records-search',
            '/profile/records-search',
            '/profile/records-search-other-users',
            '/profile/past-search'
        ];

        this.defaultImageUrl = '/assets/image_no_profilePic.png';
    }

    ngOnInit() {
        this.setLoggedInUserNameAndInitials();

        this.routerEventsSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (this.currentActiveUrl === '/profile/records-of' && event?.url !== '/profile/records-of'
                    && event?.url !== '/profile/create-update-record-of') {
                    this.store.dispatch([new ClearRecordsOf()]).subscribe();
                }
                if ((this.currentActiveUrl === '/profile/family-tree' ||
                    this.currentActiveUrl === '/profile/family-members') && event?.url !== '/profile/family-tree'
                    && event?.url !== '/profile/create-update-family-members' &&
                    event?.url !== '/profile/family-members' &&
                    event?.url !== '/profile/records-of') {
                    this.store.dispatch([new ClearFamilyTrailData()]).subscribe();
                }
                this.currentActiveUrl = event?.url;
                this.menuVisibility.header = this.getOuterMenuVisibility(event?.url);
                this.menuVisibility.inner = this.getInnerMenuVisibility(event?.url);
                this.menuVisibility.admin = this.getAdminMenuVisibility(event?.url);
                this.menuVisibility.colorLeaf = this.grayLeafMenu.indexOf(event?.url) > -1 ? false : true;
                this.adminPageTitle = this.getAdminPageTitle(event?.url);
                this.adminUserName = this.userService.getUser()?.name;
            }
        });

        this.profilePictureUrl = this.commonService.getProfilePictureUrl(this.userId);

        this.user$?.subscribe((change) => {
            this.userName = change?.name;
        });

        this.familyTrail$.subscribe(familyTrail => {
            if (familyTrail?.length > 0) {
                this.fullName = familyTrail[0]?.displayName;
                if (!this.fullName) {
                    this.fullName = familyTrail[0]?.firstName + ' ' + familyTrail[0]?.lastName;
                }
                this.visitedProfileUserId = familyTrail[0]?.userId;
            }
        });
    }

    checkAndClearStore() {
        this.store.dispatch([new ClearUpdateData()]).subscribe();
    }

    routerClicked(flag) {
        if (!this.cycanFamliyTreeClicked) {
            this.cycanFamliyTreeClicked = true;
            if (flag) {
                this.store.dispatch(new ClearFamilyTrailData()).pipe(take(1)).subscribe(() => {
                    this.familyTreeService.recordSelf.next({});
                    if (this.currentActiveUrl !== '/profile/family-tree') {
                        this.router.navigate(['/profile/family-tree']);
                    }

                    this.cycanFamliyTreeClicked = false;
                });
            } else {
                if (this.currentActiveUrl !== '/profile/family-tree') {
                    this.router.navigate(['/profile/family-tree']);
                    this.cycanFamliyTreeClicked = false;
                }
            }

        }

    }

    moveToRecordOfScreen() {
        if (!this.cycanRecordClicked) {
            this.cycanRecordClicked = true;
            this.httpService.requestCall(environment.apiUrl + GetURL.GET_SHARED_CONTACT, ApiMethod.GET, {}, {})
                .pipe(take(1)).subscribe(response => {
                    if (response && response?.success) {
                        const selectedUser = response?.data.filter(user => user?.id === this.visitedProfileUserId);
                        if (selectedUser?.length === 1) {
                            this.store.dispatch(new SetRecordsOfData({
                                rowData: JSON.stringify(selectedUser[0]), type: 'edit',
                                tags: []
                            }))
                                .subscribe(() => {
                                    this.router.navigate(['/profile/records-of']);
                                });
                        } else {
                            this.toastService.showToast(
                                this.translateService.instant('DASHBOARD.TAG.TOAST.TITLE'),
                                `No records shared from ${this.fullName} with you.`,
                                false
                            );
                        }
                    }
                    this.cycanRecordClicked = false;
                });
        }
    }

    logout(isAdmin: boolean = false) {
        this.authService.logout().subscribe(() => {
            this.store.dispatch([new ClearAdvanceSearch(), new ClearAuthState(),
            new ClearRecordsOf(), new ClearUpdateData(), new ClearFilterRecords(),
            new ClearLegacyRecords(), new ClearRecordAsSeenBy(),
            new ClearFamilyTrailData()]).subscribe(() => {
                if (isAdmin) {
                    this.router.navigate(['/admin']);
                } else {
                    this.componentMessagingService.sendMessage('logout');
                    this.router.navigate(['/']);
                }
            });
        });
    }

    setLoggedInUserNameAndInitials() {
        let user = this.userService.getUser();

        this.userId = user?.id;
        this.userName = user?.name;
        this.userEmail = user?.email;
        this.userInitials = this.commonService.generateUserInitials(user?.name);

        this.componentMessagingService.getMessage().subscribe(async (message: any) => {
            if (message.text === 'login' && message?.payload?.success === true) {
                user = this.userService.getUser();

                this.userName = user?.name;
                this.userEmail = user?.email;
                this.userInitials = this.commonService.generateUserInitials(user?.name);
                this.menuVisibility.header = true;
                this.profilePictureUrl = this.commonService.getProfilePictureUrl(user?.id);
            } else if (message.text === 'profile-picture-updated') {
                this.profilePictureUrl = this.commonService.getProfilePictureUrl(user?.id);
            } else if (message.text === 'profile-picture-deleted') {
                this.profilePictureUrl = null;
            } else if (message.text === 'logout') {
                this.menuVisibility.header = false;
                this.profilePictureUrl = null;
            }
        });
    }

    getOuterMenuVisibility(url?: string) {
        const currentUser = this.userService.getUser();

        return currentUser?.email &&
            !currentUser.roles.includes('ROLE_ADMIN') &&
            !this.outerMenuRouter.some((element) => url?.includes(element)) ? true : false;
    }

    getInnerMenuVisibility(url?: string) {
        return this.innerMenuRoutes.some((element) => url?.includes(element));
    }

    getAdminMenuVisibility(url?: string) {
        return this.adminMenuRoutes.some((element) => url?.includes(element));
    }

    getAdminPageTitle(url?: string) {
        const routeArr = url?.split('/');
        if (routeArr[routeArr.length - 1] === 'create-edit-global-user') {
            if (this.router.getCurrentNavigation().extras.state) {
                return 'Update User';
            }
            return 'Add New User';
        } else if (routeArr[routeArr.length - 1] === 'global-users-list') {
            return 'Users';
        }
        return routeArr.length > 0 ? routeArr[routeArr.length - 1]?.split('-')?.join(' ') : null;
    }

    onImageFailedToLoad() {
        this.profilePictureUrl = null;
    }

    navigateToAdminConsole() {
        this.router.navigate(['/admin/global-stats']);
    }

    public openLegacyRecords(fromWhere, fullObject) {

        this.store.dispatch(new SetLegacyRecordsData(
            { rowData: JSON.stringify(fullObject), from: fromWhere }
        )).subscribe(() => {

            let newRoute = '/profile/legacy-records';
            if (fromWhere === 'public') {
                newRoute = '/profile/legacy-public-records';
            } else if (fromWhere === 'will') {
                newRoute = '/profile/my-will-records';
            }
            this.router.navigate([newRoute]);

        });

    }

    ngOnDestroy(): void {
        this.routerEventsSubscription?.unsubscribe();
    }
}
